import React, { useEffect, useState } from 'react'
import {ReactComponent as Chip} from '../../../assets/new-icons/chip.svg';
import {ReactComponent as Asterisk} from '../../../assets/new-icons/asterisk.svg';
import ArrowForwardIos from '@mui/icons-material/ArrowForwardIos';

function Step4(props) {
    const [disabled, setDisabled] = useState(true)


    const setCVV = (e) => {
        props.setCVV(e)
        e.length > 2 ? setDisabled(false) : setDisabled(true)
    }
    const nextStep = () => {
        props.setStep(props.step + 1)
    }
 
    return (
        <div className='step1'>
            {props.idMethod === 1 ? (
                <>
                    <div className="cardContainer">
                        <div className="nameSvgContainer">
                            <p className="main p-16 mb-0">La tua carta</p>
                            <div className="cardCenter">
                                <Chip/>
                            </div>
                            <p className='number main p-16 mb-0'>{props.number && props.number.replace(/[^\dA-Z]/g, '').replace(/(.{4})/g, '$1 ').trim().slice(0, 20)}</p>

                        </div>
                        <div className="cardBottom">
                            <p className='main p-16 mb-0'>
                                {props.name}
                            </p>
                            <p className='main p-16 mb-0'>
                                {props.month} / {props.year}
                            </p>
                        </div>
                    </div>  
                    <div className="inputContainer">
                        <p className="main p-16 mb-0">Codice di controllo:</p>
                        <input type="number" placeholder='000' onChange={(e) => setCVV(e.target.value) }/>
                    </div> 
                </>
            ) : null}
             <div className="buttonActivate">
                <button disabled={disabled} onClick={() => nextStep()}>
                    Avanti <ArrowForwardIos fontSize='18px' />
                </button>
            </div>
        </div>
    )
}

export default Step4
